import {
  LEAD_CATEGORY,
  SUPPLY_NAME,
  RWA_TENURE,
  SUPPLY_DROP_DOWN,
  CORPORATE_DROP_DOWN,
  B2B_DROP_DOWN,
} from "./type";

const initalState = {
  leadCategory: [],
  splNameData: [],
  rwaTenureData: [],
  supDropDownData: [],
  corDropDownData: [],
  b2bDropDown: [],
};

const categoryDetlReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case LEAD_CATEGORY:
      return {
        ...state,
        leadCategory: payload,
      };
    case SUPPLY_NAME:
      return {
        ...state,
        splNameData: payload,
      };
    case RWA_TENURE:
      return {
        ...state,
        rwaTenureData: payload,
      };
    case SUPPLY_DROP_DOWN:
      return {
        ...state,
        supDropDownData: payload,
      };
    case CORPORATE_DROP_DOWN:
      return {
        ...state,
        corDropDownData: payload,
      };
    case B2B_DROP_DOWN:
      return {
        ...state,
        b2bDropDown: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default categoryDetlReducer;
